import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';
import { AI_DESIGN_REVIEW_PATH, AI_RESOURCE_REVIEW_PATH } from '@crema/helpers';

const ResourceCategory = React.lazy(() => import('../../modules/designManagement/ResourceCategory'));
const ResourceCategoryDetail = React.lazy(() => import('../../modules/designManagement/ResourceCategory/ResourceCategoryDetail'));
const ArtWorkResourceRegister = React.lazy(() => import('../../modules/designManagement/ArtWorkResourceRegister'));
const ClipartResourceRegister = React.lazy(() => import('../../modules/designManagement/ClipartResourceRegister'));
const AllDesignResourceDetail = React.lazy(() => import('../../modules/designManagement/AllDesignResources/AllDesignResourceDetail'));
const OrderTest = React.lazy(() => import('../../modules/designManagement/OrderTest'));
const TestOrderRegister = React.lazy(() => import('../../modules/designManagement/OrderTest/TestOrderRegister'));
const ApprovedDesigns = React.lazy(() => import('../../modules/designManagement/ApprovedDesigns'));
const DesignsOnSale = React.lazy(() => import('../../modules/designManagement/DesignsOnSale'));
const MineDesignResourceDetail = React.lazy(() => import('../../modules/designManagement/DesignResource/MineDesignResourceDetail'));
const OrderTestDetail = React.lazy(() => import('../../modules/designManagement/OrderTest/OrderTestDetail'));
const Cafe24ProductSync = React.lazy(() => import('../../modules/designManagement/Cafe24ProductSync'));
const DesignSync = React.lazy(() => import('../../modules/designManagement/DesignSync'));
const ResourceRegister = React.lazy(() => import('../../modules/designManagement/ResourceRegister'));
const ResourceUpload = React.lazy(() => import('../../modules/designManagement/resource/ResourceUpload'));
const ResourceList = React.lazy(() => import('../../modules/designManagement/resource/ResourceList'));
const Cafe24DesignTemplateSync = React.lazy(() => import('../../modules/designManagement/Cafe24DesignTemplateSync'));
const MigrationResourceReview = React.lazy(() => import('../../modules/designManagement/MigrationResourceReview'));
const AiMetaReview = React.lazy(() => import('../../modules/designManagement/AiMetaReview'));

export const designManagementConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/resourceCategory',
    element: <ResourceCategory />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/resourceCategory/detail',
    element: <ResourceCategoryDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/registerArtwork',
    element: <ArtWorkResourceRegister />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/registerClipart',
    element: <ClipartResourceRegister />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/allDesignResources',
    element: <ResourceList />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/allDesignResources/detail',
    element: <AllDesignResourceDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/orderTest',
    element: <OrderTest />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/orderTest/detail',
    element: <OrderTestDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/orderTest/register',
    element: <TestOrderRegister />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/approvedDesigns',
    element: <ApprovedDesigns />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/designsOnSale',
    element: <DesignsOnSale />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/cafe24DesignSync',
    element: <Cafe24ProductSync />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/designSync/:shopName',
    element: <DesignSync />,
  },

  {
    permittedRole: RoutePermittedRole.User,
    path: '/design',
    children: [
      {
        path: 'upload',
        element: <ResourceUpload />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/cafe24DesignTemplateSync',
    element: <Cafe24DesignTemplateSync />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/migrationResourceReview',
    element: <MigrationResourceReview />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: AI_DESIGN_REVIEW_PATH,
    element: <AiMetaReview target="design" />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: AI_RESOURCE_REVIEW_PATH,
    element: <AiMetaReview target="resource" />,
  },
];
